import { Route } from '@angular/router';

export const MANDATORY_FIELDS_ROUTING: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/mandatory-fields/mandatory-fields.component').then((m) => m.MandatoryFieldsComponent),
  },
];
